import Vue from 'vue'

Vue.prototype.$assetsBase = process.env.assetsBase
Vue.prototype.$platform = process.env.platform
Vue.prototype.$bleScanTimeout = process.env.bleScanTimeout
Vue.prototype.$releaseStage = process.env.releaseStage
Vue.prototype.$akernUrl = process.env.akernUrl
Vue.prototype.$academyUrl = process.env.academyUrl
Vue.prototype.$bodyCompositionUrl = process.env.bodyCompositionUrl
Vue.prototype.$privacyPolicyUrl = process.env.privacyPolicyUrl
